
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAppConfigApi } from "../api/appConfigApi";

export const loadAppConfig = createAsyncThunk(
    // async thunk function (= returns function [not object] that performs async operation and then dispatches action ie updates store) 
    // fetches app config data from server and returns it
    // async to ensure store loads before rendering app
    "cart/loadAppConfig", 
    async () => {
       const res = await fetchAppConfigApi();
       return res
    }
)

const initialState = {} 

export const appConfigSlice = createSlice({
    name: "appConfig", 
    initialState: {...initialState}, 
    // reducers: {
    // },

  //   define action for outcome of async thunk
  extraReducers: (builder) => {
    builder
    .addCase(loadAppConfig.fulfilled, (state, action) => {
        if(action.payload) {
            return action.payload;
        } else {
            return {...initialState}
        }
    })
    .addCase(loadAppConfig.rejected, (state, action) => {
        return {...initialState}; 
    })
  },
})


//export (reducer function + action creator + action)
// export const { } = appConfigSlice.actions;

//export reducer
export default appConfigSlice.reducer;
